import angular from 'angular';
import '../../../app/components/filter/company-autocomplete-filter.js';
import EnvelopeFilters from './envelope-filters.data';

class envelopeCtrl {
    /* @ngInject */
    constructor(
        $scope,
        $sessionStorage,
        $cookies,
        $translate,
        API_CONFIG,
        XSRF_TOKEN,
        dateFilter,
        EnvelopeService,
        uiGridConstants,
        ENVELOPE_STATUS,
        ContainerService,
        DateService,
        UtilSvc
    ) {
        this.$scope = $scope;
        this.$sessionStorage = $sessionStorage;
        this.$cookies = $cookies;
        this.$translate = $translate;
        this.API_CONFIG = API_CONFIG;
        this.XSRF_TOKEN = XSRF_TOKEN;
        this.dateFilter = dateFilter;
        this.EnvelopeService = EnvelopeService;
        this.uiGridConstants = uiGridConstants;
        this.ENVELOPE_STATUS = ENVELOPE_STATUS;
        this.ContainerService = ContainerService;
        this.DateService = DateService;
        this.UtilSvc = UtilSvc;
    }

    $onInit() {
        this.criteriaEnv = {
            envelopeId: [],
            envelopeStatus: [],
            principalId: [],
            containerId: [],
            sender: [],
            senderName: [],
            senderEmail: [],
            companyName: [],
            containerType: [],
            containerMode: [],
            refClient: [],
            createdDateFrom: [],
            createdDateTo: [],
            createdTimeFrom: [],
            createdTimeTo: [],
            updatedDateFrom: [],
            updatedDateTo: [],
            updatedTimeFrom: [],
            updatedTimeTo: [],
        };

        this.csrf = this.$cookies.get(this.XSRF_TOKEN);
        this.selected = {};

        this._initEnvelopesSearchFilter();
        this._initEnvelopesSearchValues();

        // Paramètre indiquant si les critères de recherche doivent être initialisés suivant une configuration spéciale
        var specificForm = this.specificFormEnvelope;
        if (specificForm === 'envelope_orphan') {
            this.criteriaEnv.createdDateFrom = new Date(2015, 0, 1);
            this.criteriaEnv.containerId = '0';
        } else if (specificForm === 'envelope_waiting_confirm') {
            this.criteriaEnv.createdDateFrom = new Date(2015, 0, 1);
            this.criteriaEnv.envelopeStatus = 'WAITING_CONFIRMATION';
        } else if (specificForm === 'envelope_created') {
            // Critères de recherche par défaut OK
        }

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="envelope_details({ envelopeId : row.entity.envelopeId, activeTabName: $scope.activeTabName })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        var statusCellTemplate =
            '<a class="grid-cell-link" ui-sref="envelope_details({ envelopeId : row.entity.envelopeId, activeTabName: $scope.activeTabName })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD | translate}} {{row.entity.envelopeStatus == "ERROR" ? ("status.error_" + row.entity.envelopeErrorCode | translate) : ""}}</div></a>';
        var containerTypeCellTemplate =
            '<a class="grid-cell-link" ui-sref="envelope_details({ envelopeId : row.entity.envelopeId, activeTabName: $scope.activeTabName })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{row.entity.containerMode != null ?  (("container_mode." + row.entity.containerMode | translate) + "-") : ""}}{{COL_FIELD | translate}}</div></a>';
        var companyNameTemplate =
            '<a class="grid-cell-link" ui-sref="envelope_details({ envelopeId : row.entity.envelopeId, activeTabName: $scope.activeTabName })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}{{row.entity.companyPerimeter != null ? " ("+row.entity.companyPerimeter+")" : ""}}</div></a>';

        this.envelopesGridOptions = {
            columnDefs: [
                {
                    name: 'envelopeId',
                    displayName: 'dashboard.column.envelope.id',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    type: 'number',
                },
                {
                    name: 'created',
                    displayName: 'dashboard.column.envelope.created',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    sort: { direction: this.uiGridConstants.DESC, priority: 0 },
                    cellFilter: "date:'short'",
                },
                {
                    name: 'envelopeStatus',
                    displayName: 'dashboard.column.envelope.status',
                    cellTemplate: statusCellTemplate,
                    headerCellFilter: 'translate',
                    sortingAlgorithm: function (a, b, rowA, rowB, direction) {
                        return this._sortingStatus(a, b, rowA, rowB, direction);
                    },
                },
                {
                    name: 'updated',
                    displayName: 'dashboard.column.folder.last.modified',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: "date:'short'",
                },
                {
                    name: 'containerId',
                    displayName: 'dashboard.column.envelope.container.id',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'containerType',
                    displayName: 'principal.container.column.container.type',
                    cellTemplate: containerTypeCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: 'translate',
                },
                {
                    name: 'principalName',
                    displayName: 'dashboard.column.envelope.principal',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    type: 'string',
                },
                {
                    name: 'companyName',
                    displayName: 'dashboard.column.envelope.company.name',
                    cellTemplate: companyNameTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'sender',
                    displayName: 'dashboard.column.envelope.sender',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'senderEmail',
                    displayName: 'dashboard.column.envelope.sender.email',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
                {
                    name: 'refClient',
                    displayName: 'dashboard.column.envelope.reference',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
            ],
            enableGridMenu: false,
            enableRowSelection: true,
            enableSelectAll: true,
            selectionRowHeaderWidth: 30,
            exporterMenuCsv: false,
            exporterMenuPdf: false,
            enableColumnMenus: false,
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            exporterHeaderFilter: this.$translate.instant,
            exporterFieldCallback: (grid, row, col, value) => this._exporterField(grid, row, col, value),
            gridMenuTitleFilter: this.$translate,
            onRegisterApi: gridApi => (this.gridEnvelopesApi = gridApi),
        };

        // init
        this.disableCompanyInput = true;
        var index = this.ENVELOPE_STATUS.indexOf('WAITING_VALIDATION');
        this.envelopesStatus = angular.copy(this.ENVELOPE_STATUS);
        this.envelopesStatus.splice(index, 1);

        var envelopeHistorySearchCriteria = this.$sessionStorage.envelopeHistorySearchCriteria;
        var envelopeHistorySearchCriteriaBis = this.$sessionStorage.envelopeHistorySearchCriteriaBis;
        if (envelopeHistorySearchCriteria && !specificForm) {
            this.criteriaEnv = envelopeHistorySearchCriteria;
        }
        if (envelopeHistorySearchCriteriaBis) {
            this.selected = envelopeHistorySearchCriteriaBis;
        }
    }

    clearSearchEnvelopes() {
        this._initEnvelopesSearchFilter();
        this._initEnvelopesSearchValues();
        this.envelopesGridOptions.data = this._searchByCriterias();
    }

    searchEnvelopes() {
        this._cleanEnvelopeFormParam();
        this.criteriaEnv.principalId = this.selected.principalId;
        this.criteriaEnv.companyName = this.selected.company && this.selected.company.companyName;
        this.criteriaEnv.senderName =
            this.selected.seller && this.selected.seller.legalEntity && this.selected.seller.legalEntity.name;
        this.$sessionStorage.envelopeHistorySearchCriteria = this.criteriaEnv;
        this.$sessionStorage.envelopeHistorySearchCriteriaBis = this.selected;
        this.envelopesGridOptions.data = this._searchByCriterias();
        this.envPromise = this.envelopesGridOptions.data.$promise;
    }

    // Indique si l'export CSV de la grille peut être réalisé
    canExportGrid() {
        if (!(this.gridEnvelopesApi === undefined || this.gridEnvelopesApi.selection === undefined)) {
            return this.gridEnvelopesApi.selection.getSelectedRows().length > 0;
        }
        return false;
    }

    // Exporte toutes les colonnes des lignes sélectionnées dans un fichier CSV
    exportGridCsv() {
        // Nom du fichier CSV : epdf_DateHeure_dataPlis.csv
        var now = new Date();
        var filename = 'epdf_' + this.DateService.formatAsYMD_HM(now) + '_dataPlis.csv';
        this.envelopesGridOptions.exporterCsvFilename = filename;

        var myElement = angular.element(document.querySelectorAll('.custom-csv-link-location'));
        this.gridEnvelopesApi.exporter.csvExport('selected', 'all', myElement);
    }

    getEnvelopeIdsSelected() {
        var envelopeIds = '';
        if (!(this.gridEnvelopesApi === undefined || this.gridEnvelopesApi.selection === undefined)) {
            var selectedRows = this.gridEnvelopesApi.selection.getSelectedRows();
            for (var i = 0; i < selectedRows.length; i++) {
                envelopeIds += selectedRows[i].envelopeId + ';';
            }
        }
        return envelopeIds;
    }

    /** Fournit le lien de l'export zip des plis. */
    getZipExportLink() {
        return this.API_CONFIG.url + '/v1/envelope/downloadDocuments?_csrf=' + this.csrf;
    }

    // Liste les containers disponibles en fonction de la société sélectionnée
    listContainers() {
        var containers = this.ContainerService.findAll();
        var filteredContainers = [];
        angular.forEach(containers, (value /*, key*/) => {
            var keep = false;
            if (this.selected.company) {
                keep = value.companyId === this.selected.company.companyId;
            } else if (this.selected.principalId) {
                keep = value.principalId === this.selected.principalId;
            } else {
                keep = true;
            }

            if (keep) {
                filteredContainers.push(value);
            }
        });
        return filteredContainers;
    }

    getTableHeight() {
        var rowHeight = 30;
        var headerHeight = 30;
        var scrollHeight = 20;
        var footerHeight = 32;
        return {
            height:
                this.gridEnvelopesApi.core.getVisibleRows(this.gridEnvelopesApi.grid).length * rowHeight +
                headerHeight +
                scrollHeight +
                footerHeight +
                'px',
        };
    }

    _searchByCriterias() {
        var criterias = new EnvelopeFilters();

        var createdDateFrom = this.UtilSvc.mixteDateTime(
            this.criteriaEnv.createdDateFrom,
            this.criteriaEnv.createdTimeFrom
        );
        criterias.setCreatedDateFrom(createdDateFrom);
        var createdDateTo = this.UtilSvc.mixteDateTime(this.criteriaEnv.createdDateTo, this.criteriaEnv.createdTimeTo);
        criterias.setCreatedDateTo(createdDateTo);
        var updatedDateFrom = this.UtilSvc.mixteDateTime(
            this.criteriaEnv.updatedDateFrom,
            this.criteriaEnv.updatedTimeFrom
        );
        criterias.setUpdatedDateFrom(updatedDateFrom);
        var updatedDateTo = this.UtilSvc.mixteDateTime(this.criteriaEnv.updatedDateTo, this.criteriaEnv.updatedTimeTo);
        criterias.setUpdatedDateTo(updatedDateTo);

        if (this.criteriaEnv.envelopeStatus === 'ID_TEMP') {
            criterias.setContainerType(null);
        } else {
            criterias.setContainerType(this.criteriaEnv.containerType);
        }
        criterias.setCompanyName(this.criteriaEnv.companyName);
        criterias.setContainerId(this.criteriaEnv.containerId);
        criterias.setContainerMode(this.criteriaEnv.containerMode);
        criterias.setEnvelopeId(this.criteriaEnv.envelopeId);
        criterias.setEnvelopeStatus(this.criteriaEnv.envelopeStatus);
        criterias.setPrincipalId(this.criteriaEnv.principalId);
        criterias.setRefClient(this.criteriaEnv.refClient);
        criterias.setSender(this.criteriaEnv.sender);
        criterias.setSenderName(this.criteriaEnv.senderName);
        criterias.setSenderEmail(this.criteriaEnv.senderEmail);

        return this.EnvelopeService.searchByCriterias(criterias);
    }

    _exporterField(grid, row, col, value) {
        if (col.name === 'created' || col.name === 'updated') {
            value = this.dateFilter(value, 'shortDate');
        } else if (col.name === 'containerType') {
            if (row.entity.containerType !== null) {
                value =
                    this.$translate.instant('container_mode.' + row.entity.containerMode) +
                    '-' +
                    this.$translate.instant(value);
            }
        } else if (col.name === 'envelopeStatus') {
            var origValue = value;
            value = this.$translate.instant(value);
            if (origValue === 'ERROR') {
                value =
                    this.$translate.instant(value) +
                    ' ' +
                    this.$translate.instant('status.error_' + row.entity.envelopeErrorCode);
            }
        }
        return value;
    }

    _sortingStatus(a, b, rowA, rowB /*, direction*/) {
        var statusTransA = this.$translate.instant(a);
        var statusTransB = this.$translate.instant(b);

        if (a === 'ERROR') {
            statusTransA += ' ' + this.$translate.instant('status.error_' + rowA.entity.envelopeErrorCode);
        }
        if (b === 'ERROR') {
            statusTransB += ' ' + this.$translate.instant('status.error_' + rowB.entity.envelopeErrorCode);
        }
        return statusTransA.localeCompare(statusTransB);
    }

    _initEnvelopesSearchValues() {
        this.criteriaEnv.createdDateFrom = new Date();
        this.criteriaEnv.createdDateFrom.setHours(0, 0, 0, 0);
        this.criteriaEnv.createdDateTo = new Date();
        this.criteriaEnv.createdDateTo.setHours(0, 0, 0, 0);
        this.criteriaEnv.createdTimeFrom = new Date();
        this.criteriaEnv.createdTimeFrom.setHours(0, 0, 0, 0);
        this.criteriaEnv.createdTimeTo = new Date();
        this.criteriaEnv.createdTimeTo.setHours(23, 59, 0, 0);
        this.criteriaEnv.updatedTimeFrom = new Date();
        this.criteriaEnv.updatedTimeFrom.setHours(0, 0, 0, 0);
        this.criteriaEnv.updatedTimeTo = new Date();
        this.criteriaEnv.updatedTimeTo.setHours(23, 59, 0, 0);
    }

    _cleanEnvelopeFormParam() {
        if (this.criteriaEnv.containerType === '') {
            this.criteriaEnv.containerType = undefined;
        }
        if (this.criteriaEnv.containerMode === '') {
            this.criteriaEnv.containerMode = undefined;
        }
        if (this.criteriaEnv.envelopeStatus === '') {
            this.criteriaEnv.envelopeStatus = undefined;
        }
    }

    _initEnvelopesSearchFilter() {
        this.criteriaEnv.envelopeId = undefined;
        this.criteriaEnv.envelopeStatus = undefined;
        this.criteriaEnv.principalId = undefined;
        this.criteriaEnv.containerId = undefined;
        this.criteriaEnv.sender = undefined;
        this.criteriaEnv.senderEmail = undefined;
        this.criteriaEnv.senderName = undefined;
        this.criteriaEnv.companyName = undefined;
        this.criteriaEnv.containerType = undefined;
        this.criteriaEnv.containerMode = undefined;
        this.criteriaEnv.refClient = undefined;
        this.criteriaEnv.createdDateFrom = undefined;
        this.criteriaEnv.createdDateTo = undefined;
        this.criteriaEnv.createdTimeFrom = undefined;
        this.criteriaEnv.createdTimeTo = undefined;
        this.criteriaEnv.updatedDateFrom = undefined;
        this.criteriaEnv.updatedDateTo = undefined;
        this.criteriaEnv.updatedTimeFrom = undefined;
        this.criteriaEnv.updatedTimeTo = undefined;

        this.selected.principalId = null;
        this.selected.company = null;
        this.selected.seller = null;
    }
}

angular.module('dashboard').component('envelope', {
    templateUrl: require('./envelope.html'),
    controller: envelopeCtrl,
});
